import { Box, Grid, Typography, useTheme } from '@mui/material';
import DefaultLogo from '@shared/assets/air/iconBlack.png';

import { convertToCamelCase } from '@shared/helpers';

import { sxStyled } from '../styles';

const CarrierHeader = ({ carrier = {} }) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  return (
    <Grid container style={{ display: 'flex', alignItems: 'center' }}>
      <Grid item xs={2}>
        <Box
          id="box-airline-log"
          component="img"
          sx={sxStyle.airlineLogo}
          src={carrier.logo || DefaultLogo}
          alt="aerolineas"
        />
      </Grid>
      <Grid item xs={10}>
        <Typography sx={sxStyle.carrierName}>
          {convertToCamelCase(carrier.description || carrier.code)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CarrierHeader;
